/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FORM : FIELD : SELECT : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	select: {
		backgroundColor: 'transparent',
		border: '0',
		color: 'inherit',
		fontSize: pxToEm(16),
		width: '100%',
		height: 'inherit', //pxToEm(50),
		margin: '0',
		padding: '0',
		outline: 'none',
		'&::placeholder': {
			color: theme.color.supporting.dark.swatch,
			opacity: '.4'
		}
	}
});